export { ErrorPage, type ErrorPageProps } from "./ErrorPage";
export { ErrorPage403, ErrorPage404, ErrorPage500 } from "./ErrorPage";
